module.exports = __webpack_public_path__ + "0e31ce3596b5a86c2dfb9dedf11e695b.glb";